export default __webpack_public_path__ + "static/media/arrow_down.7257d80d.svg";